import { AxiosInstance } from "axios";
import { IRequered } from "../interface/IRequered";
import { ApiService } from "../model/Api.model";

enum RequeredServiceEnum {
  get = "/get-requered-list"
}

export class RequeredService extends ApiService {
  constructor(restClient: AxiosInstance) {
    super(restClient, "/requered");
  }

  public get = async (): Promise<IRequered[]> => await this.GET(RequeredServiceEnum.get);
}